import { handleActions } from 'redux-actions';
import { DeviceGroupMap } from 'types';
import {
    DeviceGroupsLoadRequestAction,
    DeviceGroupsLoadSuccessAction,
    DeviceGroupsLoadFailureAction,
    DeviceGroupsChangedAction,
} from 'actions/deviceGroupActions';

export type State = Readonly<{
    data: Readonly<DeviceGroupMap> | null;
    loading: boolean;
    error: Error | null;
}>;

export const initialState = Object.freeze<State>({
    data: null,
    loading: false,
    error: null,
});

export type ReducerAction =
    DeviceGroupsLoadRequestAction
    | DeviceGroupsLoadSuccessAction
    | DeviceGroupsLoadFailureAction
    | DeviceGroupsChangedAction
;

export type Reducer = (state: State, action: ReducerAction) => State;

export const deviceGroupReducer: Reducer = handleActions({
    DEVICEGROUPS_LOAD_REQUEST(state: State, action: DeviceGroupsLoadRequestAction) {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    DEVICEGROUPS_LOAD_SUCCESS(state: State, action: DeviceGroupsLoadSuccessAction) {
        return {
            ...state,
            data: action.payload,
            loading: false,
            error: null,
        };
    },

    DEVICEGROUPS_LOAD_FAILURE(state: State, action: DeviceGroupsLoadFailureAction) {
        return {
            ...state,
            loading: false,
            error: action.payload,
        };
    },

    /* TODO
    DEVICEGROUPS_CHANGED(state: State, action: DeviceGroupsChangedAction) {

    },
    */

// tslint:disable-next-line:no-any
} as any, initialState) as any;



// WEBPACK FOOTER //
// ./src/reducers/deviceGroupReducer.ts